import { render, staticRenderFns } from "./BlockH2.vue?vue&type=template&id=3a4f2c73&"
import script from "./BlockH2.vue?vue&type=script&lang=js&"
export * from "./BlockH2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports